import React, {KeyboardEvent, MouseEvent, useRef} from 'react'
import {DatePicker} from 'component/Datepicker'
import 'component/Datepicker'
import {getSisDateAsNumber, parseSisDate} from 'util/SisDateTime'
import moment from 'moment'
import './CustomFieldDateComponent.css'
import {focusNextFormElement} from 'util/view/focusNextFormElement'
import {CFComponentProps} from 'module/CustomField/type/CFComponentType'
import {stripHTML} from 'util/StringUtil'
import ReactDatePicker from 'react-datepicker'

interface CustomFieldDateComponentProps extends CFComponentProps<number | null | undefined> {
	isClearable?: boolean
}

export function CustomFieldDateComponent({modelValue, disabled, setCb, placeholderHTML}: CustomFieldDateComponentProps) {
	const onChange = (date: Date) => {
		if (disabled) return;
		setCb(getSisDateAsNumber(moment(date)))
	}
	const onBlur = (event: React.FocusEvent<HTMLInputElement>) => {
		if (disabled) return;
		setCb(getSisDateAsNumber(event.target.value))
	}
	const mom = modelValue && parseSisDate(modelValue) || undefined
	let selected = mom?.isValid() ? mom?.toDate() : null
	const ref = useRef<ReactDatePicker>(null)
	return (
		<div className={'CustomFieldDateComponent'}>
			<DatePicker
				ref={ref}
				placeholderText={stripHTML(placeholderHTML)}
				selected={selected}
				disabled={disabled}
				onChange={onChange}
				onBlur={onBlur}
				onSelect={(date: Date | null, evt: MouseEvent<HTMLElement> | KeyboardEvent<HTMLElement>) => (evt as React.KeyboardEvent<HTMLElement>)?.key !== 'Enter' && focusNextFormElement(1, ref.current?.input as HTMLInputElement)}
				todayButton={"Heute"}
				isClearable={false}
			/>
		</div>
	)
}
